export default __webpack_public_path__ + "static/media/accessories-4.090212eb.jpg";